// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Spinner_fullWidth__oUZGV","fullHeight":"Spinner_fullHeight__wNx0e","root":"Spinner_root__1So2k"};